import React, { useState, useContext } from 'react'
import Heading from '../../GitHubComponents/Heading'
import {Input} from '../../GitHubComponents/Inputs'
import Button from '../../GitHubComponents/Button'
import "./user.css"
import { MyContext } from '../..'
import { changePasswordByUser } from "../../services";
import Alert from '@mui/material/Alert';

export default function Account(props) {
    document.title = props.title
    const username = props.userData.username
    const { backendUrl } = useContext(MyContext);

    const [formData, setFormData] = useState({
        // Initialize the form fields with default values or leave them empty
        username: username,
        oldPassword: "",
        newPassword1: "",
        newPassword2: "",
        changerRole: props.role
    });
    const [alert, setAlert] = useState({
        show: false,
        message: "",
        type: ""
    })

    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // You can handle form submission logic here
        const response = await changePasswordByUser(backendUrl, formData);
        if (response.code === 200) {
            console.log("Password updated successfully");
            setAlert({
                type: "success",
                message: response.message,
                show: true,
            });
            setFormData({
                username: username,
                oldPassword: "",
                newPassword1: "",
                newPassword2: "",
                changerRole: props.role
            })
        } else {
            setAlert({
                type: "error",
                message: response.message,
                show: true,
            });
        }
    };
    return (
        <div className='account-body'>
            {alert.show && <Alert variant={"outlined"} severity={alert.type} onClose={() => {setAlert({show: false})}} style={{margin: "10px auto"}}>{alert.message}</Alert>}
            <div className="account-section">
                <Heading heading="Change password" />
                <form onSubmit={handleSubmit}>
                    {["a", "i", "su"].includes(props.role) === false && <Input type={"password"} id={"oldpassword"} name={"oldPassword"} lable={"Old password"} value={formData.oldPassword} onChange={handleChange} minLength={5} required="true" />}
                    <Input type={"password"} id={"newpassword1"} name={"newPassword1"} lable={"New password"} value={formData.newPassword1} onChange={handleChange} minLength={5} required="true" />
                    <Input type={"password"} id={"newpassword2"} name={"newPassword2"} lable={"Confirm new password"} value={formData.newPassword2} onChange={handleChange} minLength={5} required="true" />
                    <p>Make sure both new password should match contain atleast five characters and old password should be your current password.</p>
                    <Button text={"Update password"} type={"submit"} />
                </form>
            </div>
        </div>
    )
}
